import { SvgSymbol } from '../symbol-factory';

export const ChevronThinUp: SvgSymbol = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.12537 11.3031C3.95821 11.1359 3.95821 10.8643 4.12537 10.6972L8.69677 6.12577C8.86446 5.95808 9.13554 5.95808 9.30323 6.12577L13.8746 10.6972C14.0418 10.8643 14.0418 11.1359 13.8746 11.3031C13.7075 11.4708 13.4359 11.4708 13.2687 11.3031L8.99999 7.03492L4.73127 11.3031C4.56412 11.4708 4.29252 11.4708 4.12537 11.3031Z"
    />
  </svg>
);
